<script setup lang="ts">
/**
 * AiOrbButton — Floating AI button wrapper around the shared AiOrbIcon.
 * The orb visual lives entirely in AiOrbIcon (single source of truth); this just wraps it
 * in a clickable button so all orbs stay consistent.
 */
import AiOrbIcon from '@/components/ai-chat/AiOrbIcon.vue'
defineEmits<{ (_e: 'click'): void }>()
</script>

<template>
  <button
    class="ai-orb group w-9 h-9 flex items-center justify-center flex-shrink-0 transition-transform hover:scale-110"
    title="Open AI assistant"
    @click="$emit('click')"
  >
    <AiOrbIcon :size="30" animated />
  </button>
</template>

<style scoped>
.ai-orb {
  cursor: pointer;
  background: transparent;
  border: none;
  outline: none;
}
</style>
